export const PREDICTION_OPTIONS = [
  { value: '', label: 'Nicht vorhersagen', short: 'Keine' },
  { value: 'rolling_average', label: 'Konstanter Durchschnitt', short: 'Durchschnitt' },
  { value: 'ses', label: 'Aktuelles Niveau', short: 'Niveau' },
  { value: 'seasonal', label: 'Saisonale Schwankung', short: 'Saisonal' }
];

export const PREDICTION_DESCRIPTIONS = {
  rolling_average: 'Mittelwert der letzten 6 Monate. Ideal für gleichmäßige Ausgaben wie Lebensmittel oder Tanken.',
  ses: 'Neuere Monate zählen stärker. Gut, wenn sich das Ausgabenniveau kürzlich geändert hat.',
  seasonal: 'Nutzt den gleichen Monat des Vorjahres. Für jährliche Muster wie Heizkosten oder Urlaub.'
};

export const predictionLabel = (type) => {
  const opt = PREDICTION_OPTIONS.find(o => o.value === (type || ''));
  return opt ? opt.label : 'Nicht vorhersagen';
};
